import axios, { AxiosError } from 'axios';

// needs to be in sync with WAF Cause Responses
export const WAF_COUNTRY_BLOCKED_CAUSE = 'ae851728-f072-4a19-a4f9-67261e6f9c15';

// needs to be in sync with WAF Cause Responses
const WAF_BLOCKED_CAUSES = new Set([
  '1d724a0f-5e65-44cb-a1df-9296cd37a7d6',
  'b3f2a1e4-9c8d-4f7b-a2e1-3d5c6b8a9f0e',
  'c4e3b2f5-0d9e-4a8c-b3f2-4e6d7c9b0a1f',
  'd5f4c3a6-1e0f-4b9d-c4a3-5f7e8d0c1b2a',
  WAF_COUNTRY_BLOCKED_CAUSE,
]);

export function isWafBlockedError(err: unknown): boolean {
  return axios.isAxiosError(err) && WAF_BLOCKED_CAUSES.has(err.response?.data?.cause);
}

export class WafBlockedError extends Error {
  constructor(public readonly wafCause: string) {
    super(`WAF blocked request (cause: ${wafCause})`);
    this.name = 'WafBlockedError';
  }
}

export type WafBlockedMessageKey = 'wafBlockedMessage' | 'wafCountryBlockedMessage';

export function getWafBlockedMessageKey(cause: string | undefined): WafBlockedMessageKey {
  return cause === WAF_COUNTRY_BLOCKED_CAUSE ? 'wafCountryBlockedMessage' : 'wafBlockedMessage';
}

export function normalizeApiError(err: Error): Error {
  if (isWafBlockedError(err)) {
    return new WafBlockedError(((err as AxiosError).response?.data as { cause?: string })?.cause ?? 'unknown');
  }
  return err;
}

export function catchNotFound(err: unknown): null {
  if (axios.isAxiosError(err) && err.response?.status === 404) {
    return null;
  }
  throw err;
}
